var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeatMap11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 85,
    viewBox: "0 0 77 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    filter: "url(#filter0_f_1693_26282)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.2826 11.2193C44.7612 10.3056 44.1653 9.48162 43.5049 8.74062C27.5728 -9.13553 0.785682 20.161 3.47224 43.9554C4.82329 55.9214 9.25902 67.2288 18.5997 74.6814C38.1131 90.2506 36.5547 80.5295 63.7839 51.4055C91.013 22.2816 54.1599 26.7771 45.2826 11.2193Z",
    fill: "url(#paint0_linear_1693_26282)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2826 11.2193C44.7612 10.3056 44.1653 9.48162 43.5049 8.74062C27.5728 -9.13553 0.785682 20.161 3.47224 43.9554C4.82329 55.9214 9.25902 67.2288 18.5997 74.6814C38.1131 90.2506 36.5547 80.5295 63.7839 51.4055C91.013 22.2816 54.1599 26.7771 45.2826 11.2193Z",
    stroke: "#52CB74"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1693_26282",
    x: 0.78418,
    y: 0.728516,
    width: 75.3613,
    height: 83.8232,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_1693_26282"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1693_26282",
    x1: 24.1623,
    y1: 17.677,
    x2: 59.7159,
    y2: 85.7681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A9FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#FFF744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E13827"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatMap11);
export default __webpack_public_path__ + "static/media/heatMap11.9ce72c734ceccf30fe15957864daaa56.svg";
export { ForwardRef as ReactComponent };